import React, { useEffect, useState } from 'react';
import './MfaSettingsTab.css';
import { Form, Button, Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { QrgeneratorActionHandler } from '../../../../Redux/Actions/user/SettingsOrGenerator';
import { QrCodeVerifyActionHandler } from '../../../../Redux/Actions/user/SettingsOrCodeVerify';
import QRCode from 'qrcode.react';
import { notification } from 'antd';
import VerificationInput from 'react-verification-input';

const MfaSettingsTab = () => {
    const dispatch = useDispatch();
    const [qrCodeData, setQrCodeData] = useState(false);
    const [verificationValue, setVerificationValue] = useState('');
    const [api, contextHolder] = notification.useNotification();
    const [isVerificationCodeOpen, setIsVerificationCodeOpen] = useState(false);
    const [isGeneratQr, setIsGeneratQr] = useState(false);

    const CodeData = useSelector(
        (state) => state?.SettingsOrGeneratorData?.mfasettings_data?.data?.code
    );
    const qrVerifyCodeData = useSelector(
        (state) => state?.SettingsCodeVerifyData?.qrVerifyCodeMessage
    );
    const openNotificationWithIcon = (type) => {
        api[type]({ message: qrVerifyCodeData });
    };
    useEffect(() => {
        if (CodeData) {
            const userDetails = JSON.parse(localStorage.getItem('userDetails'));
            const appName = process.env.REACT_APP_NAME || 'QuickAction';
            const generatedQrCodeData = `otpauth://totp/${encodeURIComponent(
                appName
            )}:${encodeURIComponent(
                userDetails.email
            )}?secret=${encodeURIComponent(
                CodeData
            )}&issuer=${encodeURIComponent(appName)}`;
            setQrCodeData(generatedQrCodeData);
        }
    }, [CodeData]);

    useEffect(() => {
        if (qrVerifyCodeData) {
            openNotificationWithIcon('success');
        }
    }, [qrVerifyCodeData]);

    const onQRCode = async () => {
        dispatch(QrgeneratorActionHandler());
        setIsGeneratQr(!isGeneratQr);
    };

    const handleCodeText = () => {
        setQrCodeData(!qrCodeData);
        setIsVerificationCodeOpen(!isVerificationCodeOpen);
    };
    const handleVerificationChange = (value) => {
        setVerificationValue(value);
    };

    const onVerifyCodeFinish = (values) => {
        dispatch(QrCodeVerifyActionHandler(verificationValue));
    };
    const mfaStatus = JSON.parse(localStorage.getItem('userDetails'));
    return (
        <>
            <div>
                {contextHolder}
                <div className='mfa-settings-container'>
                    {isGeneratQr ? null : (
                        <>
                            <div className='mfa-settings-main'>
                                <div>
                                    <h3>
                                        Continue with Multi Factor
                                        Authentication
                                    </h3>
                                    <Switch
                                        checked={mfaStatus.is_mfa_enabled}
                                    />
                                    <Button
                                        onClick={onQRCode}
                                        className='mfa-settings-qrcode-button'>
                                        QRCode Generator
                                    </Button>
                                </div>
                            </div>
                        </>
                    )}
                    {qrCodeData ? (
                        <>
                            <h5>
                                Scan this QR code with your verification app
                            </h5>
                            <div className='mfa-settings-qrcode-verifiction'>
                                <QRCode value={qrCodeData} />
                            </div>
                            <p className='mfa-settings-qrcode-div-p'>
                                Can’t scan the code?{' '}
                                <span
                                    className='mfa-settings-qrcode-div-span'
                                    onClick={handleCodeText}>
                                    Click Here
                                </span>
                            </p>
                        </>
                    ) : null}
                    {isVerificationCodeOpen ? (
                        <>
                            <h5>Enter your verification code to continue.</h5>
                            <div className='mfa-settings-main'>
                                <Form
                                    name='verification'
                                    initialValues={{ code: '' }}
                                    onFinish={onVerifyCodeFinish}>
                                    <div className='Verification_input'>
                                        <label>Verification Code</label>
                                        <VerificationInput
                                            value={verificationValue}
                                            onChange={handleVerificationChange}
                                        />
                                    </div>
                                    <Form.Item>
                                        <Button
                                            type='primary'
                                            htmlType='submit'
                                            block
                                            className='submit_login-btn mfa-settings-marginTop-30'>
                                            Verify and Login
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </>
                    ) : null}
                </div>
            </div>
        </>
    );
};
export default MfaSettingsTab;
